import { PageLoader } from '@forwardflow/ui/PageLoader'
import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'

import Campaign from '../../pages/Campaign'
import CampaignList from '../../components/Campaign/CampaignList'
import CampaignLeads from '../../components/Campaign/LeadSourceList'
import ActivateCampaignPage from '../../pages/Campaign/ActivateCampaign'
import PhoneNumber from '../../pages/Campaign/ActivateCampaign/PhoneNumber'
import CampaignUSP from '../../pages/Campaign/ActivateCampaign/CampaignUSP'
import Assistants from '../../pages/Campaign/ActivateCampaign/Assistants'
import WorkingHours from '../../pages/Campaign/ActivateCampaign/WorkingHours'
import QualifyingQuestionsPage from '../../pages/Campaign/ActivateCampaign/QualifyingQuestions'
import FirstToContactPage from '../../pages/Campaign/ActivateCampaign/FirstToContact'
import AppointmentTimeFramePage from '../../pages/Campaign/ActivateCampaign/AppointmentTimeframes'
import StageMappingPage from '../../pages/Campaign/ActivateCampaign/StageMapping'
import ConfigCampaign from '../../pages/Campaign/ConfigCampaignPage'
import WaitingTimePage from '../../pages/Campaign/ActivateCampaign/WaitingTimePage'

const CampaignRoutes = () => {
   return (
      <Suspense fallback={<PageLoader />}>
         <Routes>
            <Route path="" element={<Campaign />}>
               <Route path="" element={<CampaignList />} />
               <Route path=":title" element={<CampaignLeads />} />
            </Route>
            <Route
               path=":title/activate"
               element={<ActivateCampaignPage />}
            ></Route>
            <Route path=":title" element={<ConfigCampaign />}>
               <Route path="phone-number" element={<PhoneNumber />} />
               <Route path="campaign-usp" element={<CampaignUSP />} />
               <Route path="assistants" element={<Assistants />} />
               <Route path="working-hours" element={<WorkingHours />} />
               <Route
                  path="appointment-timeframes"
                  element={<AppointmentTimeFramePage />}
               />
               <Route
                  path="qualifying-questions"
                  element={<QualifyingQuestionsPage />}
               />
               <Route
                  path="first-to-contact"
                  element={<FirstToContactPage />}
               />
               <Route path="waiting-time" element={<WaitingTimePage />} />
               <Route path="stage-mapping" element={<StageMappingPage />} />
            </Route>
         </Routes>
      </Suspense>
   )
}
export default CampaignRoutes
